import { useOpstelClient } from "@opstel/contexts/opstelClient/useOpstelClient";
import { instances } from "@opstel/query/queryKeys/instanceKeys";
import { conflictSchema } from "@opstel/query/v2/conflictsParser";
import { Conflict } from "@opstel/query/v2/models/conflict";
import { useCurrentInstanceId } from "@shared/common/contexts/instanceMetadata/useInstanceId";
import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { z } from "zod";

export function useConflictsQuery(): UseQueryResult<Conflict[]> {
  const { opstelClient } = useOpstelClient();
  const { instanceId } = useCurrentInstanceId();

  return useQuery({
    queryKey: instances.current(instanceId).conflicts,
    queryFn: () => opstelClient.getConflicts({ instanceId: instanceId ?? "" }),
    select: (conflict): Conflict[] => z.array(conflictSchema).parse(conflict),
    enabled: !!instanceId,
  });
}
